window.onload = (event) => {
  console.log("page is loaded");
  //document.querySelector('afterpay-placement').shadow.querySelector('p').style.color = "#6e6e6e";
};

function zoom_img() {
  if(window.matchMedia("(hover: hover)").matches) {
    const container = document.querySelector(".image-slide.is-selected");
    const img = document.querySelector(".image-slide.is-selected img");
    const rect = img.getBoundingClientRect();
    container.addEventListener("mousemove", onZoom);
    container.addEventListener("mouseover", onZoom);
    container.addEventListener("mouseleave", offZoom);
    function onZoom(e) {
      const x = e.clientX - rect.x;
      const y = e.clientY - rect.y;
      img.style.transformOrigin = `${x}px ${y}px`;
      img.style.transform = "scale(2.5)";
    }
    function offZoom(e) {
        img.style.transformOrigin = `center center`;
        img.style.transform = "scale(1)";
    } 
  }
};

function make_carousel(Carousel) {
  //Carousel = document.querySelector(".js-product-rec-wrapper .js-carousel");
    if (!Carousel) {
      console.log("couldn't build carousel")
      return false;
    }
    console.log("carousel on the way!");
    const flktyData = Carousel.getAttribute('data-flickity');
    const flktyOptions = JSON.parse(flktyData);
    new Flickity( Carousel, flktyOptions);
    console.log("flikity set up");
}

// Custom filter bar behaviour
var open_filter_menu = false;

// function toggle_filter_menu(elem_id){
//   let filter_bar = document.getElementById("filter-bar");
//   let filter_group_display = document.getElementById("filter-group-display-"+elem_id);
//   let display_height = filter_group_display.offsetHeight;
//   let filter_group_summary = document.getElementById("filter-group-"+elem_id).firstElementChild;
  
//   if (open_filter_menu == elem_id){
//   	open_filter_menu = false;
//     filter_bar.style.paddingBottom = "20px";
//     filter_group_display.style.visibility = "hidden";
//   } else if (open_filter_menu == false){
//   	open_filter_menu = elem_id;
//     filter_bar.style.paddingBottom = `${display_height+20}px`;
//     filter_group_display.style.visibility = "visible";
//   } else {
//   	let prev_filter_group_display = document.getElementById("filter-group-display-"+open_filter_menu);
//     let prev_filter_group_summary = document.getElementById("filter-group-"+open_filter_menu).firstElementChild;
//     filter_bar.style.paddingBottom = `${display_height+20}px`;
//     prev_filter_group_display.style.visibility = "hidden";
//     prev_filter_group_summary.classList.toggle("toggled");
//     filter_group_display.style.visibility = "visible";
//     open_filter_menu = elem_id;
//   }
//   filter_group_summary.classList.toggle("toggled");
// }

function toggle_filter_menu(elem_id) {
  let filter_bar = document.getElementById("filter-bar");
  let filter_group_display = document.getElementById("filter-group-display-" + elem_id);
  let display_height = filter_group_display.offsetHeight;
  let filter_group_summary = document.getElementById("filter-group-" + elem_id).firstElementChild;

  // Update aria-expanded for the current summary element
  let isExpanded = filter_group_summary.getAttribute("aria-expanded") === "true";

  if (open_filter_menu == elem_id) {
    open_filter_menu = false;
    filter_bar.style.paddingBottom = "20px";
    filter_group_display.style.visibility = "hidden";
    // Toggle aria-expanded to false when collapsing
    filter_group_summary.setAttribute("aria-expanded", "false");
  } else if (open_filter_menu == false) {
    open_filter_menu = elem_id;
    filter_bar.style.paddingBottom = `${display_height + 20}px`;
    filter_group_display.style.visibility = "visible";
    // Set aria-expanded to true when expanding
    filter_group_summary.setAttribute("aria-expanded", "true");
  } else {
    let prev_filter_group_display = document.getElementById("filter-group-display-" + open_filter_menu);
    let prev_filter_group_summary = document.getElementById("filter-group-" + open_filter_menu).firstElementChild;
    filter_bar.style.paddingBottom = `${display_height + 20}px`;
    prev_filter_group_display.style.visibility = "hidden";
    prev_filter_group_summary.classList.toggle("toggled");
    filter_group_display.style.visibility = "visible";
    open_filter_menu = elem_id;

    // Set aria-expanded to true for the newly expanded element
    filter_group_summary.setAttribute("aria-expanded", "true");
    // Set aria-expanded to false for the previous element
    prev_filter_group_summary.setAttribute("aria-expanded", "false");
  }

  filter_group_summary.classList.toggle("toggled");
  // Optionally, add aria-controls to the summary element to associate it with the expanded content
  filter_group_summary.setAttribute("aria-controls", "filter-group-display-" + elem_id);
}


function toggle_accordion_menu(elem_id){
  let accordion_label = document.getElementById("filter-accordion-label-"+elem_id).closest("li");
  let accordion_content = document.getElementById("filter-accordion-content-"+elem_id);
  accordion_content.classList.toggle("collapsed")
  accordion_label.classList.toggle("toggled");
}

function toggle_filter_overlay(){
  let overlay = document.getElementById("filter-overlay");
  if (overlay.style.display == "none"){
  	overlay.style.display = "block";
  }	else {
  	overlay.style.display = "none";
  }
}
